module.exports = __webpack_public_path__ + "img/bg.83851c27.jpg";